<template>
  <div>
    <Header />
    <div>
      <div class="background-wrapper">
        <h2 class="text-center font-weight-bold text-white" style="padding-top: 150px">Give</h2>
        <div class="text-center mt-5"></div>
      </div>
    </div>

    <div class="text-justify container">
      <!-- <h4 class="mt-4"><span>"</span> <span>"</span>
      </h4>
      <p> - Genesis 26: 12</p> -->

      <div class="vc_column-inner">
        <div class="wpb_wrapper">
          <blockquote class="max-quote">
            <h2>Then Isaac sowed in that land, and reaped in the same year a
        hundredfold; and the Lord blessed him. </h2><cite title="">Genesis 26: 12 <small></small></cite>
          </blockquote>
        </div>
      </div>
    </div>


    <!-- <div class="mt-5">
          <h4>Online Giving</h4>
          <p>No registration or account needed.
            Give securely using your debit or credit Card.</p>

        </div> -->

    <div class="event">
      <div class="event_wrapper">

        <div class="event_wrapper-body">
          <h4>ONLINE GIVING</h4>
          <p>No registration or account needed.
            Give securely using your debit or credit Card.</p>
        </div>

        <div class="event_wrapper-button">
          <button class="btn-jscc" @click="toggleGiveForm">Give</button>
        </div>

      </div>
    </div>


    <div class="mt-5 pb-5 container">
      <h4>Bank Transfer</h4>
      <p class="pb-3">You can give by direct transfer to any of our accounts below:</p>

      <table class="table table-striped">
        <thead>
          <tr>
            <!-- <th scope="col">Account Name</th> -->
            <th scope="col">Account Number</th>
            <th scope="col">Bank Name</th>
            <th scope="col">Purpose</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <!-- <td>Jesus The Saviour Catholic church</td> -->
            <td>1011542789</td>
            <td>Zenith Bank</td>
            <td>Tithes and Bulletin Sponsorship, Silent Giving, Support Of Parish Evagelization
            </td>
          </tr>
          <tr>
            <!-- <td>Jesus The Saviour Catholic church</td> -->
            <td>2001570017</td>
            <td>First City Monument Bank (FCMB)</td>
            <td>Parish Project and Harvest</td>
          </tr>
        </tbody>
      </table>

    </div>

  <GiveForm v-if="isGiveForm" @close="toggleGiveForm"></GiveForm>
    <Footer />
    <BackUp />

  </div>
</template>

<script>
import Footer from '@/components/navigation/Footer.vue';
import Header from '@/components/navigation/Header.vue';
import BackUp from '@/components/BackUp.vue';
import GiveForm from '@/components/forms/GiveForm.vue';
export default {
  data() {
    return {
      isGiveForm: false
    }
  },
  components: {
    Footer,
    Header,
    BackUp,
    GiveForm
  },

  methods: {
    toggleGiveForm() {
      this.isGiveForm = !this.isGiveForm
    }
  }

}
</script>

<style scoped>
.background-wrapper {
  background: url('../assets/Images/wheat.jpg');
  background-repeat: no-repeat;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height: 400px;
  position: relative;
  z-index: 1;
}

.event_wrapper {
  height: 250px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0 6rem;
  background: linear-gradient(rgba(48, 48, 54, .8), rgba(44, 33, 36, .8)), url("../assets/Images/wallet.jpg");
  background-position-x: 0%, 0%;
  background-position-y: 0%, 0%;
  background-repeat: repeat, repeat;
  background-attachment: scroll, scroll;
  background-size: auto, auto;
  margin-top: 4rem;
  text-align: left;
  align-items: center;
  background-size: cover;
  justify-content: space-between;
  background-repeat: no-repeat;
  background-position: center;
  background-attachment: fixed;
}

.event_wrapper-body h4 {
  font-size: 2.3rem;
  letter-spacing: 3px;
  color: #fff;
  margin: 0;
  font-weight: 700;
}

.event_wrapper-body p {
  font-size: 1.3rem;
  letter-spacing: 3px;
  color: #fff;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: 0.00938em;
}

.max-quote {
    text-align: center;
    padding: 15px 0;
}
blockquote {
    position: relative;
    margin: 0 0 21px;
    padding: 18px 10px 14px 60px;
}
blockquote, blockquote p, q {
    font-size: 15px;
    line-height: 24px;
    color: #3a3b3c;
    font-family: 'Lora', serif;
    font-style: italic;
}
blockquote, q {
    quotes: none;
}

#wrap .max-quote h2 {
    font-family: 'Lora',serif;
    font-size: 23px;
    line-height: 1.6;
    letter-spacing: 0;

}

.max-quote small {
    display: block;
    padding-top: 4px;
    font-style: normal;
    letter-spacing: 2px;
    font-size: 11px;
    color: #a1a1a1;
}
</style>
